import React from "react";
import Detail from "features/WarrantyRequest/SerialDetail";

function SerialDetail() {
  return <Detail />;
}

export default SerialDetail;
